import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

import { buttons as Buttons, pills as Pills } from '@breezeway/brzw-components';

import './select_pill.scss';

const SelectPill = ({ selected, elements, onClick, big }) => (
  <div className="select-pill">
    <div className="select-pill__wrapper">
      {_.map(elements, (element, index) =>
        big ? (
          <Buttons.TextButton
            autoWidth
            className="select-pill__button"
            key={`select-pill-${index}`}
            onClick={() => onClick(element, index)}
            theme={_.find(selected, { name: element.name }) ? 'dark' : 'outline'}
          >
            {element.name}
          </Buttons.TextButton>
        ) : (
          <div className="select-pill__pill-wrapper" key={`select-pill-wrapper-${index}`}>
            <Pills.Pill
              key={`select-pill-${index}`}
              onClick={() => onClick(element, index)}
              text={element.name}
            />
          </div>
        ),
      )}
    </div>
  </div>
);

SelectPill.propTypes = {
  big: PropTypes.bool,
  onClick: PropTypes.func,
  elements: PropTypes.array.isRequired,
  selected: PropTypes.array,
};

SelectPill.defaultProps = {
  big: false,
};

export default SelectPill;
